import { render, staticRenderFns } from "./NextPeriodDateDlg.vue?vue&type=template&id=2064e8c3"
import script from "./NextPeriodDateDlg.vue?vue&type=script&lang=js"
export * from "./NextPeriodDateDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports